import html_default from "./template.default.html?raw";
const app_theme = import.meta.env.VITE_APP_THEME;
let html = "";
if ("default" == app_theme) {
  html = html_default;
}
import { ref, type SetupContext } from "vue";
import LoginCode from "../LoginCode/index.ts";

interface Props {
  // E-Mail aus dem Gast-Formular: dann direkt die Code-Maske zeigen und den Code anfordern
  initialEmail: string;
}

// Schritt "Wer bucht": zwei Karten. "Ich habe schon einmal gebucht" oeffnet die Code-Maske, "Ich bin neu" geht direkt weiter.
export default {
  template: html,
  components: { LoginCode },
  emits: {
    onLoggedIn: () => true,
    onNew: (email: string) => typeof email === "string",
  },
  props: {
    initialEmail: { type: String, required: false, default: "" },
  },
  setup(props: Props, { emit }: SetupContext) {
    const mode = ref<"choose" | "login">(props.initialEmail ? "login" : "choose");

    return {
      props,
      mode,
      chooseLogin: () => (mode.value = "login"),
      chooseNew: () => emit("onNew", ""),
      onLoggedIn: () => emit("onLoggedIn"),
      onUnknownEmail: (email: string) => emit("onNew", email),
      onCancel: () => (mode.value = "choose"),
    };
  },
};
